import { ComponentPropsWithoutRef } from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';
import { Dialog, DialogOverlay, DialogContent } from '@reach/dialog';

import ThinCrossIcon from '#/assets/ThinCrossIcon';

import { c07071D, c080018, cBC44FF, cFFFFFF } from '#/colors';

export type ModalProps = ComponentPropsWithoutRef<typeof Dialog>;

export function Modal(props: ModalProps) {
  return (
    <BaseModal {...props}>
      <Grid>{props.children}</Grid>
    </BaseModal>
  );
}

const Grid = styled.div`
  display: grid;
  gap: 16px;
`;

function BaseModal(props: ModalProps) {
  const { isOpen, onDismiss, children, ...rest } = props;
  return (
    <StyledDialogOverlay isOpen={isOpen} onDismiss={onDismiss}>
      <StyledDialogContent {...rest}>{children}</StyledDialogContent>
    </StyledDialogOverlay>
  );
}

const StyledDialogOverlay = styled(DialogOverlay)`
  z-index: 1;
  backdrop-filter: blur(6px);
  background: ${rgba(c080018, 0.5)};
`;

const StyledDialogContent = styled(DialogContent)`
  width: 400px;
  border-radius: 10px;
  background-color: ${c07071D};
  box-shadow: 0 2px 50px 0 ${rgba(cBC44FF, 0.3)};
  padding: 20px;
`;

export const ModalHeader = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

export const ModalTitle = styled.h1`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  margin: 0;
`;

export const ModalCloseButton = styled.button.attrs({
  children: <ThinCrossIcon size={14} />,
  type: 'button',
  'aria-label': 'Close',
})`
  background: none;
  border: none;
  color: ${cFFFFFF};
  line-height: 1px;
  border-radius: 4px;

  /* Increased clickable area */
  padding: 5px;
  margin: -5px;
`;
